import {
  DEFAULT_LIST_IDS,
  defaultListsFor,
  withConsents,
} from '../../constants/whatsapp-contacts';

export const NAME = 'WHATSAPP';

export const types = {
  SAVE_LIST: `${NAME}/SAVE_LIST`,
  DELETE_LIST: `${NAME}/DELETE_LIST`,
  SET_CONSENTS: `${NAME}/SET_CONSENTS`,
  SET_COMPANIES: `${NAME}/SET_COMPANIES`,
  COMPANIES_ERROR: `${NAME}/COMPANIES_ERROR`,
  SET_LISTS: `${NAME}/SET_LISTS`,
  LISTS_LOADING: `${NAME}/LISTS_LOADING`,
  LISTS_ERROR: `${NAME}/LISTS_ERROR`,
  SET_TEMPLATES: `${NAME}/SET_TEMPLATES`,
  TEMPLATES_LOADING: `${NAME}/TEMPLATES_LOADING`,
  TEMPLATES_ERROR: `${NAME}/TEMPLATES_ERROR`,
  SET_CONVERSATIONS: `${NAME}/SET_CONVERSATIONS`,
  CONVERSATIONS_ERROR: `${NAME}/CONVERSATIONS_ERROR`,
  SET_THREAD: `${NAME}/SET_THREAD`,
  SET_REPLY_STATE: `${NAME}/SET_REPLY_STATE`,
};

export const initialState = {
  // Исходная база и то, что сервер знает о согласии каждого контакта (ответы клиентов,
  // СТОП, ручные отметки).
  consents: [],
  // Клиенты основной системы, и они же с отметками о согласии.
  baseContacts: [],
  contacts: [],
  contactsLoadedAt: 0,
  contactsError: '',
  // Компании, у которых нет номера, пригодного для WhatsApp.
  withoutPhone: 0,
  withoutPhoneCompanies: [],
  lists: defaultListsFor([]),
  listsFromDb: [],
  listsLoading: false,
  listsError: '',
  templates: [],
  templatesLoading: false,
  templatesError: '',
  conversations: [],
  conversationsLoaded: false,
  conversationsError: '',
  thread: { phone: '', messages: [] },
  // Можно ли ответить клиенту свободным текстом: окно 24 часа и месячный лимит.
  // secondsLeft действителен на момент receivedAt, дальше экран считает сам.
  replyState: { phone: '', receivedAt: 0, secondsLeft: 0, used: 0, limit: 0, allowed: true, blocker: '', maxLength: 4096 },
};

export function reducer(state = initialState, action) {
  switch (action.type) {
    case types.LISTS_LOADING:
      return { ...state, listsLoading: true, listsError: '' };
    case types.LISTS_ERROR:
      return { ...state, listsLoading: false, listsError: action.payload };
    case types.SET_LISTS:
      return {
        ...state,
        listsLoading: false,
        listsError: '',
        lists: [...defaultListsFor(state.baseContacts), ...action.payload],
        listsFromDb: action.payload,
      };
    case types.TEMPLATES_LOADING:
      return { ...state, templatesLoading: true, templatesError: '' };
    case types.TEMPLATES_ERROR:
      return { ...state, templatesLoading: false, templatesError: action.payload };
    case types.SET_TEMPLATES:
      return {
        ...state,
        templatesLoading: false,
        templatesError: '',
        templates: action.payload,
      };
    case types.SET_CONVERSATIONS:
      return {
        ...state,
        conversations: action.payload,
        conversationsLoaded: true,
        conversationsError: '',
      };
    case types.CONVERSATIONS_ERROR:
      return { ...state, conversationsLoaded: true, conversationsError: action.payload };
    case types.SET_THREAD:
      return { ...state, thread: action.payload };
    case types.SET_REPLY_STATE:
      return { ...state, replyState: action.payload };
    case types.SAVE_LIST: {
      const list = action.payload;
      const exists = state.lists.some((item) => item.id === list.id);
      return {
        ...state,
        lists: exists
          ? state.lists.map((item) => (item.id === list.id ? list : item))
          : [...state.lists, list],
      };
    }
    case types.DELETE_LIST:
      return {
        ...state,
        lists: state.lists.filter((item) => item.id !== action.payload),
      };
    case types.SET_CONSENTS:
      return {
        ...state,
        consents: action.payload,
        contacts: withConsents(state.baseContacts, action.payload),
      };
    case types.SET_COMPANIES: {
      const baseContacts = action.payload.contacts;
      return {
        ...state,
        baseContacts,
        contacts: withConsents(baseContacts, state.consents),
        contactsLoadedAt: Date.now(),
        contactsError: '',
        withoutPhone: action.payload.withoutPhone,
        withoutPhoneCompanies: action.payload.withoutPhoneCompanies,
        // Свои списки менеджера остаются, начальные пересчитываются по новой базе.
        lists: [
          ...defaultListsFor(baseContacts),
          ...state.lists.filter((list) => !DEFAULT_LIST_IDS.includes(list.id)),
        ],
      };
    }
    case types.COMPANIES_ERROR:
      return { ...state, contactsError: action.payload };
    default:
      return state;
  }
}
